(function () {

    angular
        .module('app')
        .run(run);

    run.$inject = [
        '$rootScope',
        '$state',
        '$transitions',
        'authService', 'authManager', 'sitealertsService', 'loggerService'
    ];

    function run($rootScope, $state, $transitions, authService, authManager, sitealertsService, loggerService) {
        var MANAGED_TOOL_REASON = 'tool.managed_by_platform';
        var MANAGED_TOOL_NOTICE = '请从具体任务进入创作工具';
        $rootScope.productNotice = null;
        $rootScope.dismissProductNotice = function () {
            $rootScope.productNotice = null;
        };
        // Put the authService on $rootScope so its methods
        // can be accessed from the nav bar
        $rootScope.authService = authService;

        // Put the loggerService on $rootScope so the nav
        // bar can download the log
        $rootScope.loggerService = loggerService;

        // register auth listener
        authService.setupAuth();

        // check auth when they load or refresh the page
        authManager.checkAuthOnRefresh();

        // send them back to the login screen if they get an HTTP 401
        //  from an API call
        authManager.redirectWhenUnauthenticated();

        // display confirmation if the user is verifying their
        //  email address with Auth0
        authService.checkForAuthMessagesInUrl();

        function getDefaultState(productContext) {
            return authService.getDefaultStateName(productContext);
        }

        function getStateAccess(toState) {
            return toState && toState.data ? toState.data.access : undefined;
        }

        function isPublicState(toState) {
            var access = getStateAccess(toState);
            return access === 'public';
        }

        function isManagedToolRedirectState(toState) {
            return Boolean(toState && toState.data && toState.data.managedToolRedirect === true);
        }

        function applyManagedToolNotice(reason) {
            if (reason === MANAGED_TOOL_REASON) {
                $rootScope.productNotice = MANAGED_TOOL_NOTICE;
            }
        }

        function userHasRequiredRole(productContext, toState) {
            if (!productContext) {
                return false;
            }

            var access = getStateAccess(toState);
            if (access === 'public' || access === 'authenticated') {
                return true;
            }
            if (access === 'teacher') {
                return productContext.productRole === 'teacher';
            }
            if (access === 'teacher_or_siteadmin') {
                return productContext.productRole === 'teacher' ||
                    productContext.productRole === 'platform_ops';
            }
            if (access === 'student') {
                return productContext.productRole === 'student';
            }
            if (access === 'siteadmin') {
                return productContext.productRole === 'platform_ops';
            }
            if (access === 'orgadmin') {
                return productContext.productRole === 'orgadmin';
            }
            return false;
        }

        function ignoreSupersededTransition(err) {
            return err && (
                err.type === 2 ||
                String(err.message || '').indexOf('superseded') !== -1
            );
        }

        function targetState(transition, stateName, stateParams) {
            return transition.router.stateService.target(stateName, stateParams || {});
        }

        if ($state.defaultErrorHandler) {
            $state.defaultErrorHandler(function (err) {
                if (!ignoreSupersededTransition(err)) {
                    loggerService.error('[qitan-router] transition failed', err);
                }
            });
        }

        $transitions.onBefore({}, function (transition) {
            var toState = transition.to();
            var toParams = transition.params('to');
            if (!toState || !toState.name) {
                return true;
            }

            applyManagedToolNotice(toParams && toParams.reason);

            if (isManagedToolRedirectState(toState)) {
                applyManagedToolNotice(MANAGED_TOOL_REASON);
                if (!authService.isAuthenticated()) {
                    return targetState(transition, 'login', { reason : MANAGED_TOOL_REASON });
                }
                return authService.getProductContext()
                    .then(function (productContext) {
                        return targetState(
                            transition,
                            getDefaultState(productContext),
                            { reason : MANAGED_TOOL_REASON }
                        );
                    })
                    .catch(function (err) {
                        if (!ignoreSupersededTransition(err)) {
                            loggerService.error('[qitan-router] managed tool redirect rejected', err);
                        }
                        return targetState(transition, 'login', { reason : MANAGED_TOOL_REASON });
                    });
            }

            if (isPublicState(toState)) {
                return true;
            }

            if (!authService.isAuthenticated()) {
                authService.rememberStateForLogin(toState.name, toParams);
                return targetState(transition, 'login');
            }

            return authService.getProductContext()
                .then(function (productContext) {
                    if (userHasRequiredRole(productContext, toState)) {
                        return true;
                    }
                    return targetState(transition, getDefaultState(productContext));
                })
                .catch(function (err) {
                    if (!ignoreSupersededTransition(err)) {
                        loggerService.error('[qitan-router] product role guard failed', err);
                    }
                    return targetState(
                        transition,
                        authService.isAuthenticated() ? 'welcome' : 'login'
                    );
                });
        });

        // prepare the service for fetching site alerts
        sitealertsService.init();
    }
})();
